import { defineComponent as C, inject as S, ref as o, computed as T, watchEffect as I, h as d } from "vue";
import E from "./ghl-ui.es1345.js";
import B from "./ghl-ui.es1346.js";
import { dataTableInjectionKey as z } from "./ghl-ui.es992.js";
import { formatLength as h } from "./ghl-ui.es1026.js";
const $ = C({
  name: "MainTable",
  setup() {
    const {
      mergedClsPrefixRef: t,
      rightFixedColumnsRef: i,
      leftFixedColumnsRef: l,
      bodyWidthRef: n,
      maxHeightRef: u,
      minHeightRef: b,
      flexHeightRef: g,
      syncScrollState: R
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = S(z), c = o(null), s = o(null), m = o(null), r = o(!(l.value.length || i.value.length)), v = T(() => ({
      maxHeight: h(u.value),
      minHeight: h(b.value)
    }));
    function y(e) {
      n.value = e.contentRect.width, R(), r.value || (r.value = !0);
    }
    function x() {
      const {
        value: e
      } = c;
      return e ? e.$el : null;
    }
    function H() {
      const {
        value: e
      } = s;
      return e ? e.getScrollContainer() : null;
    }
    const p = {
      getBodyElement: H,
      getHeaderElement: x,
      scrollTo(e, a) {
        var f;
        (f = s.value) === null || f === void 0 || f.scrollTo(e, a);
      }
    };
    return I(() => {
      const {
        value: e
      } = m;
      if (!e)
        return;
      const a = `${t.value}-data-table-base-table--transition-disabled`;
      r.value ? setTimeout(() => {
        e.classList.remove(a);
      }, 0) : e.classList.add(a);
    }), Object.assign({
      maxHeight: u,
      mergedClsPrefix: t,
      selfElRef: m,
      headerInstRef: c,
      bodyInstRef: s,
      bodyStyle: v,
      flexHeight: g,
      handleBodyResize: y
    }, p);
  },
  render() {
    const {
      mergedClsPrefix: t,
      maxHeight: i,
      flexHeight: l
    } = this, n = i === void 0 && !l;
    return d("div", {
      class: `${t}-data-table-base-table`,
      ref: "selfElRef"
    }, n ? null : d(E, {
      ref: "headerInstRef"
    }), d(B, {
      ref: "bodyInstRef",
      bodyStyle: this.bodyStyle,
      showHeader: n,
      flexHeight: l,
      onResize: this.handleBodyResize
    }));
  }
});
export {
  $ as default
};
